module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_15_20.f4a23e9c.png";